import { c as _c } from "react/compiler-runtime";
import { useJwtToken } from "@website/hooks/auth-manager";
import { daysBetweenDates } from "@website/utils/date-format";
import { numberConvert } from "@website/utils/number-convert";
import snappProIcon from "@website/widget/header/assets/pro_badge.svg";
export const useSnappPro = () => {
  const $ = _c(9);
  const {
    snapp_pro
  } = useJwtToken();
  const hasSnappPro = Boolean(snapp_pro);
  let t0;
  if ($[0] !== hasSnappPro || $[1] !== snapp_pro?.expiration_date) {
    t0 = hasSnappPro ? daysBetweenDates(new Date(), snapp_pro?.expiration_date) : 0;
    $[0] = hasSnappPro;
    $[1] = snapp_pro?.expiration_date;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const rawRemainingDays = t0;
  const snappProRemainingDays = Math.max(0, rawRemainingDays);
  const t1 = snappProRemainingDays > 0;
  const t2 = (snappProIcon as unknown as {
    src: string;
  }).src;
  let t3;
  if ($[3] !== snappProRemainingDays) {
    t3 = numberConvert(snappProRemainingDays, {
      locale: "fa"
    });
    $[3] = snappProRemainingDays;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${t3} روز باقی‌مانده`;
  let t5;
  if ($[5] !== snappProRemainingDays || $[6] !== t1 || $[7] !== t4) {
    t5 = {
      hasSnappPro: t1,
      snappProRemainingDays,
      snappProIcon: t2,
      snappProTitle: "\u0627\u0633\u0646\u067E \u067E\u0631\u0648",
      snappProSubTitle: t4
    };
    $[5] = snappProRemainingDays;
    $[6] = t1;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};